import { useEffect } from "react";
import { Country } from "../Languages";
export const pixelByLocale: Record<Country, string> = {
    AT: "342977598601718",
    BR: "399107303163902",
    CH: "409984321552050",
    CZ: "409984321552050",
    DE: "342977598601718",
    ES: "3307312559400849",
    FR: "1481886385869470",
    GB: "409984321552050",
    IT: "1003365600958879",
    PL: "1626854444718804",
    PT: "3772851749618794",
    SE: "468346532760120",
    RO: "1911142016075771",
    BE: "1212335403592159",
    EE: "",
    GR: "1567814440541054",
    LT: "",
    LV: "",
    MX: "564434376599922",
    NL: "655378737180475",
    TR: "",
    CA: "698598449489880",
    TN: "1624916518155400",
    MA: "1333098391237792",
};

// track user interaction via clarity without setting cookies
export const useMetaPixel = (hasConsent: boolean, locale?: Country) => {
    useEffect(() => {
        if (!locale) return;

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // @ts-ignore
        if (!window.fbq) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            !(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "2.0";
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        }

        // @ts-ignore
        if (!!window.fbq) {
            if (!hasConsent) {
                // @ts-ignore
                window.fbq("consent", "revoke");
            }
            if (hasConsent) {
                // @ts-ignore
                window.fbq("consent", "grant");
            }
            // @ts-ignore
            window.fbq("init", pixelByLocale[locale]);
            // @ts-ignore
            window.fbq("track", "PageView");
        }
    }, [hasConsent]);

    return locale ? pixelByLocale[locale] : undefined;
};
